import React, { Component, forwardRef } from "react";
import PropTypes from "prop-types";
import CoreCard from "./CoreCard";
import { Droppable, Draggable, DragDropContext } from "react-beautiful-dnd";
import { withStyles } from "@material-ui/core/styles";
import { withTheme } from "@material-ui/core/styles";
import axiosImport from "axios";
import axios, {
  contentClient,
  discussionClient,
  reportClient,
  notificationClient,
} from "../AxiosClient";
import hash from "object-hash";
import PubSub from "pubsub-js";
import {
  USER_LIST,
  USER_LIST_ADD,
  USER_LIST_DELETE,
  HOT_TOPIC_UPDATE,
  HOT_TOPIC_ADD,
} from "../utils/Topics";
import Skeleton from "@material-ui/lab/Skeleton";
import Typography from "@material-ui/core/Typography";
import { connect } from "react-redux";
import { Virtuoso } from "react-virtuoso";
import { AutoSizer } from "react-virtualized";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Button from "@material-ui/core/Button";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { Trans, withTranslation } from "react-i18next";
import Pagination from "@material-ui/lab/Pagination";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Tooltip from "@material-ui/core/Tooltip";
import ReactDOM from "react-dom";
import { PORTLET_LAYOUT_UPDATE } from "../utils/Topics";
import GetAppIcon from "@material-ui/icons/GetApp";
import Link from "@material-ui/core/Link";
import moment from "moment";
const styles = (theme) => ({
  step: {
    color: "white",
    width: 5,
    height: 20,
    fontSize: 12,
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transform: "rotate(25deg)",
  },
  centerText: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  container: {
    maxWidth: "98%",
    maxHeight: 620,
    marginLeft: "auto",
    marginRight: "auto",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2),
  },
  sticky: {
    position: "sticky",
    left: 0,
    zIndex: 100,
    width: theme.spacing(2),
  },
});
export class CardList extends Component {
  static propTypes = {
    messageType: PropTypes.string.isRequired,
    portlet: PropTypes.object.isRequired,
    messageParameters: PropTypes.string,
    fullscreen: PropTypes.bool,
  };
  cancelToken = null;

  state = {
    data: [],
    isEditingContents: true,
    fullscreenPageSize: 20,
    pageSize: this.props.rows ? this.props.rows * 10 : 10,
    startIndex: 0,
    paginate: true,
    loading: true,
    error: false,
    isAtEnd: false,
    savingList: false,
    page: 0,
    totalItems: 0,
    totalPages: 0,
    columnSorts: [],
    settingsFullscreen: [],
    fullwidth: false,
    parameters: null,
    downloadReady: false,
    listMinHeight: "200px",
  };

  componentDidMount() {
    this.userListToken = PubSub.subscribe(USER_LIST, this.userListSubscriber);
    this.props.refCallback && this.props.refCallback(this);
    if (this.props.portlet.parameters) {
      this.setState({
        parameters:
          typeof this.props.portlet.parameters !== "object"
            ? JSON.parse(this.props.portlet.parameters)
            : { ...this.props.portlet.parameters },
      });
    }
    this.setColumnSorts();
    if (this.props.expanded) {
      this.getData();
    }

    this.setState({
      settingsFullscreen:
        this.props.portlet.settingsFullscreen &&
        this.props.portlet.settingsFullscreen.length > 0
          ? JSON.parse(this.props.portlet.settingsFullscreen)
          : this.getDefaultExtendedSetting(),
    });
    this.props.width > 2 && this.setState({ fullwidth: true });
    if (
      (this.props.width > 2  || this.props.portlet.fullscreen ) &&
      this.props.portlet.fullscreenPagination
    ) {
      let fullscreenPagination = JSON.parse(
          this.props.portlet.fullscreenPagination
        );

      if (!fullscreenPagination) { 
        fullscreenPagination = 
          {
            pageSize: 20,
            page: 0,
          }
      }
      this.setState(
        {
          fullscreenPageSize: fullscreenPagination.pageSize,
        },
        () => this.setState({ page: fullscreenPagination.page ? fullscreenPagination.page : 0 })
      );

    }
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this.userListToken);
  }

  componentDidUpdate(prevProps, prevState) {
    let hasGottenData = false;
    if (this.state.data != prevState.data && this.props.updateData) {
      this.props.updateData(this.state.data);
    }
    if (
      (this.state.fullwidth || this.props.fullscreen) &&
      (prevState.page !== this.state.page ||
        prevState.fullscreenPageSize !== this.state.fullscreenPageSize)
    ) {
      this.props.updateFullscreenPagination(
        this.state.fullscreenPageSize,
        this.state.page
      );
    }
    this.props.portlet.parameters != prevProps.portlet.parameters &&
      this.props.portlet.parameters &&
      this.setState({
        parameters:
          typeof this.props.portlet.parameters !== "object"
            ? JSON.parse(this.props.portlet.parameters)
            : this.props.portlet.parameters,
      });

    if (prevProps.width !== this.props.width) {
      this.setState({ fullwidth: this.props.width > 2 ? true : false });
    }

    if (prevProps.rows !== this.props.rows && this.state.pageSize !== this.props.rows * 10) {
      this.setState({ pageSize: this.props.rows * 10 }, () => {
        this.getData();
      });
    }

    if (prevProps.fullscreen !== this.props.fullscreen) {
      this.props.fullscreen === true
        ? this.setState({
            listMinHeight: "500px",
          })
        : this.setState({ listMinHeight: "200px" });
      this.getData(true);
    }

    if (
      this.props.portlet.settingsFullscreen !=
      prevProps.portlet.settingsFullscreen
    ) {
      let params =
        typeof this.props.portlet.parameters === "string" ||
        this.props.portlet.parameters instanceof String
          ? JSON.parse(this.props.portlet.parameters)
          : this.props.portlet.parameters;

      // let params = JSON.parse(this.props.portlet.parameters);
      let settings =
        this.props.portlet.settingsFullscreen &&
        this.props.portlet.settingsFullscreen.length > 0
          ? JSON.parse(this.props.portlet.settingsFullscreen)
          : this.getDefaultExtendedSetting();
      this.setState({ settingsFullscreen: settings });
    }

    // if (this.props.fullscreen !== prevProps.fullscreen) {
    //   this.setState({ startIndex: 0, page: 0, data: [], loading: true }, () => {
    //     this.getData();
    //   });
    // }
    if (
      prevState.savingList !== this.state.savingList &&
      !this.state.savingList
    ) {
      this.getData();
    }
    // if (
    //   this.props.notifications !== prevProps.notifications &&
    //   this.props.messageType ===
    //     "com.kpsol.api.apicommon.hottopic.HotTopicInterface"
    // ) {
    //   this.setState({ data: this.props.notifications });
    // }
    if (
      (this.props.fullscreen !== prevProps.fullscreen &&
        this.props.fullscreen === false) ||
      prevProps.parameters !== this.props.parameters ||
      // prevState.pageSize !== this.state.pageSize ||
      prevState.fullscreenPageSize !== this.state.fullscreenPageSize
    ) {
      hasGottenData=true;
      this.setState(
        { paginate: true, startIndex: 0, page: 0, data: [], loading: true },
        () => {
          this.getData();
        }
      );
    }
    if (prevProps.portlet !== this.props.portlet && !hasGottenData) {
      if (prevProps.portlet.parameters !== this.props.portlet.parameters) {
        this.setState(
          { startIndex: 0, paginate: true, page: 0, data: [], loading: true },
          () => {
            this.getData();
          }
        );
      }
    }
    // if (
    //   prevState.pageSize !== this.state.pageSize ||
    //   prevState.fullscreenPageSize !== this.state.fullscreenPageSize
    // ) {
    //   this.setState(
    //     { startIndex: 0, paginate: true, page: 0, data: [], loading: true },
    //     () => {
    //       this.getData();
    //     }
    //   );
    // }
    if (prevState.page !== this.state.page) {
      this.setState(
        {
          startIndex: this.state.page * this.state.pageSize,
          paginate: true,
          data: [],
          loading: true,
        },
        () => {
          this.getData();
        }
      );
    }
    if (
      this.props.portlet.objectClass ===
      "com.kpsol.api.apicommon.list.UserListInterface"
    ) {
      if (
        JSON.stringify(prevState.data) !== JSON.stringify(this.state.data) &&
        !this.state.loading
      ) {
        if (
          this.props.messageType !==
          "com.kpsol.api.apicommon.layout.LayoutPortletInterface"
        ) {
          this.saveList();
        }
      }
    }
    if (
      prevProps.expanded !== this.props.expanded &&
      this.props.expanded &&
      this.state.data.length < 0
    ) {
      this.getData();
    }
  }
  setColumnSorts = () => {
    let settings;
    switch (this.props.portlet.objectClass) {
      case "com.kpsol.api.apicommon.document.DocumentInterface":
      case "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface":
      case "com.kpsol.api.apicommon.document.ReportInterface":
        settings = [
          // {label: "", value: "createdDate"},
          {
            label: "settings_document_date_last_viewed_by_me",
            value: "lastViewedByMe",
          },
          { label: "settings_document_number_of_times_used", value: "used" },
          {
            label: "settings_document_number_of_times_viewed",
            value: "viewed",
          },
          {
            label: "settings_document_number_of_times_favourited",
            value: "favourited",
          },
          {
            label: "settings_document_number_of_liked",
            value: "liked",
          },
          this.props.listItemTitleColumn !== null && {
            label: this.props.listItemTitleColumn.message,
            value: this.props.listItemTitleColumn.name,
          },
          {
            label: "settings_document_last_date_modified",
            value: "modifiedDate",
          },
          { label: "settings_document_created_date", value: "createdDate" },
          {
            label: "settings_document_revalidation_date",
            value: "revalidationDate",
          },
        ];
        break;
      case "com.kpsol.api.apicommon.history.SearchHistoryInterface":
      case "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface":
        settings = [
          {
            label: "settings_searchhistory_searchText",
            value: "searchString",
          },
          {
            label: "settings_searchhistory_last_searched",
            value: "lastSearchedDate",
          },
          {
            label: "settings_searchhistory_total",
            value: "searches",
          },
          {
            label: "settings_searchhistory_viewCount",
            value: "views",
          },
          {
            label: "settings_searchhistory_usedCount",
            value: "attached",
          },
          {
            label: "settings_searchhistory_userCount",
            value: "users",
          },
          {
            label: "settings_searchhistory_numberOfResults",
            value: "results",
          },
        ];
        break;
      case "com.kpsol.api.apicommon.rework.ReworkInterface":
        settings = [
          {
            label: "global_rework",
            value: "targetTitle",
          },
          {
            label: "settings_date_created",
            value: "dateCreated",
          },
          {
            label: "settings_target_completion_date",
            value: "targetCompletionDate",
          },
          {
            label: "settings_urgency",
            value: "urgency",
          },
          {
            label: "settings_originator",
            value: "creator",
          },
        ];
        break;
      case "com.kpsol.api.apicommon.requiredreading.RequiredReadingInterface":
        settings = [
          {
            label: "required_reading_date_created",
            value: "createdDate",
          },
          {
            label: "required_reading_expiry_date",
            value: "expiryDate",
          },
          {
            label: "required_reading_number_of_documents",
            value: "requiredReadingDocuments.length",
          },
          {
            label: "global_title",
            value: "title",
          },
          {
            label: "required_reading_description",
            value: "description",
          },
        ];
        break;
      case "com.kpsol.api.apicommon.content.KnowledgeItemInterface":
        settings = [
          {
            label: "settings_knowledge_item_document_title",
            value: "documentTitle",
          },
          {
            label: "settings_knowledge_item_withdraw_date",
            value: "withdrawDate",
          },
          {
            label: "settings_knowledge_item_modified_date",
            value: "modifiedDate",
          },
          {
            label: "settings_knowledge_item_created_date",
            value: "createdDate",
          },
          this.props.listItemTitleColumn !== null && {
            label: this.props.listItemTitleColumn.message,
            value: this.props.listItemTitleColumn.name,
          },
        ];
        break;
      case "com.kpsol.api.apicommon.discussions.EntryInterface":
      case "com.kpsol.api.apicommon.discussions.DiscussionIndexInterface":
        settings = [
          {
            label: "global_title",
            value: "title",
          },
          {
            label: "settings_expert_question_status",
            value: "expertQuestionStatus",
          },
          {
            label: "settings_expert_question_visibility",
            value: "expertQuestionVisibility",
          },
          {
            label: "settings_discussions_date_created",
            value: "createdDate",
          },
          {
            label: "settings_discussions_number_views",
            value: "views",
          },
          {
            label: "settings_discussions_number_posts",
            value: "posts",
          },
          {
            label: "settings_discussions_date_last_post",
            value: "lastPost",
          },
        ];
        // settings.unshift({
        //   label: "Hello",
        //   value: "erwerwer",
        // });
        break;
      case "com.kpsol.api.apicommon.expertquestion.ExpertQuestionInterface":
        settings = [
          {
            label: "global_title",
            value: "title",
          },
          {
            label: "settings_expert_question_status",
            value: "expertQuestionStatus",
          },
          {
            label: "settings_expert_question_visibility",
            value: "expertQuestionVisibility",
          },
          {
            label: "settings_discussions_date_created",
            value: "createdDate",
          },
          {
            label: "settings_discussions_number_views",
            value: "views",
          },
          {
            label: "settings_discussions_number_posts",
            value: "posts",
          },
          {
            label: "settings_discussions_date_last_post",
            value: "lastPost",
          },
          {
            label: "settings_expert_question_urgency",
            value: "urgency",
          },
        ];
        break;
      default:
        settings = [];
    }
    this.setState({ columnSorts: settings });
  };

  prepareTaxonomyNodes = (taxonomyFilter) => {
    //Create a list of TaxonomySelections (taxonomies or communities)

    //filter taxonomies to only include those whose parent is not present (otherwise they are included implicitly)
    let taxonomies = taxonomyFilter.filter(
      (ele) => ele.type === "taxonomy" && ele.children.length > 0
    );

    //get all the topic nodes and filter any whose parents are in the list of taxonomies and filter out any duplicates
    let topics = taxonomyFilter
      .filter((ele) => ele.type === "topic")
      .filter((ele) => {
        return (
          ele.type === "topic" &&
          ele.parentList &&
          ele.parentList.length > 0 &&
          taxonomies
            .map((t) => t.id)
            .indexOf(ele.parentList[ele.parentList.length - 1]) === -1
        );
      })
      .filter((topic, index, topicArray) => {
        const _topic = JSON.stringify(topic);
        return (
          index ===
          topicArray.findIndex((obj) => {
            return JSON.stringify(obj) === _topic;
          })
        );
      });

    if (topics.length > 0) {
      topics = topics
        .filter(
          (topic) => taxonomies.map((ele) => ele.id).indexOf(topic.id) === -1
        )
        .map((ele) => {
          return {
            id: ele.object ? ele.object[ele.type + "Id"] : ele.id,
            type: ele.type,
          };
        });
    }
    //now process the taxonomies and put the nodes highest up the list into a filtered list
    let filteredTaxonomies = [];
    let sorted = taxonomies.sort((a, b) => {
      return a.parentList.length > b.parentList.length
        ? 1
        : a.parentList.length < b.parentList.length
          ? -1
          : 0;
    });
    sorted.forEach(
      (tax) =>
        taxonomies
          .map((ele) => ele.id)
          .indexOf(tax.parentList[tax.parentList.length - 1]) === -1 &&
        filteredTaxonomies.push(tax)
    );
    let filtered =
      topics &&
      topics.concat(
        filteredTaxonomies.map((ele) => {
          return { id: ele.id, type: ele.type };
        })
      );
    return filtered;
  };

  userListSubscriber = (msg, data) => {
    switch (msg) {
      case USER_LIST_ADD:
        this.getData();
        break;
      case USER_LIST_DELETE:
        this.getData();
      case HOT_TOPIC_UPDATE:
        this.getData();
        break;
      case HOT_TOPIC_ADD:
        this.getData();
        break;
      default:
        break;
    }
  };

  // filterNotifications = (notifications, params) => {
  //   if (params.onlyUnread) {
  //     notifications = notifications.filter((n) => {
  //       return !n.isViewed;
  //     });
  //   }
  //   if (params.notificationType) {
  //     notifications = notifications.filter((n) => {
  //       if (params.notificationType === "messages") {
  //         return n.content && n.content !== "";
  //       }
  //       if (params.notificationType === "alerts") {
  //         return n.targetType !== "REQUIRED_READING";
  //       }
  //       if (params.notificationType === "required_reading") {
  //         return n.targetType === "REQUIRED_READING";
  //       }
  //       return true;
  //     });
  //   }
  //   return notifications;
  // };

  getData = (force) => {
    if (!force && this.state.savingList) return;
    if (!force && !this.state.paginate && !this.props.menuDialog) return;
    if (this.cancelToken && this.cancelToken.cancel) {
      // cancel inflight data request
      this.cancelToken.cancel();
    }
    if (this.props.expanded) {
      if (this.props.parameters) {
        var parameters = { ...this.props.parameters };
      } else {
        var parameters = this.props.portlet.parameters
          ? this.props.portlet.parameters !== "null"
            ? typeof this.props.portlet.parameters !== "object"
              ? JSON.parse(this.props.portlet.parameters)
              : this.props.portlet.parameters
            : {}
          : {};
      }
      // if ((typeof parameters === "object") && parameters != null) {
      parameters.taxonomySelection = parameters.hasOwnProperty("taxonomy")
        ? parameters.taxonomy //this.prepareTaxonomyNodes(parameters.taxonomy)
        : [];
      // }

      parameters.taxonomy = [];
      this.sendRequest(parameters, false, null);
    }
  };
  sendRequest = (parameters) => {
    this.props.menuDialog === true && this.setState({ data: [] });
    parameters.size =
      this.props.fullscreen === true ||
      this.props.menuDialog ||
      this.state.fullwidth
        ? this.state.fullscreenPageSize
        : this.state.pageSize!=null && this.state.pageSize;
    parameters.page =
      this.props.fullscreen === true ||
      this.props.menuDialog ||
      this.state.fullwidth
        ? this.state.page
        : this.state.startIndex;
    

    if (parameters.taxonomySelection){
      parameters.taxonomySelection = parameters.taxonomySelection.map((tax)=> {
        return {id:tax.id,type:tax.type}
    })}

    // if (
    //   localStorage.getItem("fullscreenPortletItemClicked") === "false" &&
    //   this.props.fullscreen
    // ) {
    //   localStorage.setItem(
    //     "fullscreenPortletSettings",
    //     JSON.stringify(parameters)
    //   );
    // }

    let axiosInstance = axios;
    let url = "";
    switch (this.props.messageType) {
      case "com.kpsol.api.apicommon.hottopic.HotTopicInterface":
        // special case, notifications are in redux
        // this.setState({
        //   loading: false,
        //   isAtEnd: true,
        //   data: this.filterNotifications(this.props.notifications, parameters),
        // });
        axiosInstance = notificationClient;
        url = "/notification";
        break;
      case "com.kpsol.api.apicommon.rework.ReworkInterface":
        axiosInstance = contentClient;
        url = "/rework/filter";
        break;
      case "com.kpsol.api.apicommon.document.ReportInterface":
        url = "/document/reports";
        break;
      case "com.kpsol.api.apicommon.document.DocumentInterface":
      case "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface":
        url = "/document/";
        break;
      case "com.kpsol.api.apicommon.history.SearchHistoryInterface":
        url = "/searchhistory/filter";
        break;
      case "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface":
        url = "/searchhistory/all/filter";
        break;
      case "com.kpsol.api.apicommon.content.KnowledgeItemInterface":
        axiosInstance = contentClient;
        url = "/knowledgeitem/filter";
        break;
      case "com.kpsol.api.apicommon.discussions.DiscussionIndexInterface":
        axiosInstance = discussionClient;
        url = "/discussion/filter/";
        break;
      case "com.kpsol.api.apicommon.requiredreading.RequiredReadingInterface":
        url = "/requiredreading/alerted";
        break;
      case "com.kpsol.api.apicommon.discussions.EntryInterface":
        axiosInstance = discussionClient;
        url = "/entry/filter";
        break;
      case "com.kpsol.api.apicommon.list.ListUserListsInterface":
        url = "/userlist/list";
        break;
      case "com.kpsol.api.apicommon.stats.MyStatsInterface":
        axiosInstance = reportClient;
        url = "/mystats/";
        break;
      case "com.kpsol.api.apicommon.list.UserListInterface":
        url = `/userlist/${parameters.listID}/items`;
        break;
      case "com.kpsol.api.apicommon.expertquestion.ExpertQuestionInterface":
        axiosInstance = discussionClient;
        url = "/expertquestion/";
        break;
      default:
        break;
    }

    // if (
    //   localStorage.getItem("fullscreenPortletSettings") !== null &&
    //   this.props.fullscreen &&
    //   localStorage.getItem("fullscreenPortletItemClicked") === "true"
    // ) {
    //   let parameters = JSON.parse(
    //     localStorage.getItem("fullscreenPortletSettings")
    //   );
    //   localStorage.setItem("fullscreenPortletItemClicked", false);
    //   this.setState({
    //     fullscreenPageSize: parameters.size,
    //     page: parameters.page,
    //     startIndex: parameters.page * parameters.size,
    //   });
    // }
    this.cancelToken = axiosImport.CancelToken.source();
    url === "/document/" ||
    url === "/document/reports" ||
    url === "/knowledgeitem/filter" ||
    url === "/requiredreading/alerted" ||
    url === "/expertquestion/" ||
    url === "/discussion/filter/" ||
    url === "/entry/filter" ||
    url === "/rework/filter" ||
    url === "/searchhistory/filter" ||
    url === "/searchhistory/all/filter" ||
    url === "/userlist/list" || 
    url === "/notification"
      ? axiosInstance
          .post(url, parameters, { cancelToken: this.cancelToken.token })
          .then((res) => {
            this.setState({
              loading: false,
              error: false,
              totalItems: res.data.totalElements,
              totalPages: res.data.totalPages,
            });
            if (res.data.numberOfElements > this.state.pageSize - 1) {
              this.setState({ startIndex: res.data.number + 1 });
            } else {
              if (res.data.numberOfElements < this.state.pageSize) {
                this.setState({ isAtEnd: true });
              }
              this.setState({ paginate: false });
            }
            if (res.data.number === 0) {
              this.setState({ data: res.data.content });
            } else {
              this.setState({
                data: [...this.state.data, ...res.data.content],
              });
            }
          })
          .catch((err) => {
            if (axiosImport.isCancel(err)) return;
            this.setState({ loading: false, error: true });
          })
      : axiosInstance
          .get(url, {
            paramsSerializer: (params) => this.parseParams(params),
            params: parameters,
            cancelToken: this.cancelToken.token,
          })
          .then((res) => {
            if (res.data.numberOfElements > 9) {
              this.setState({ startIndex: res.data.number + 1 });
            } else {
              if (res.data.numberOfElements < this.state.pageSize) {
                this.setState({ isAtEnd: true });
              }
              this.setState({ paginate: false });
            }
            if (res.data.number === 0) {
              this.setState({ data: res.data.content });
            } else {
              this.setState({
                data: [...this.state.data, ...res.data.content],
              });
            }
            this.setState({ loading: false, error: false });
          })
          .catch((err) => {
            if (axiosImport.isCancel(err)) return;
            this.setState({ loading: false, error: true });
          });
  };

  exportToCSV = () => {
    let data = this.prepareDownloadData(this.state.data);
    console.log(data);
    let csv = "";
    if (data.length > 0) {
      let keyObj = data[0];
      if (keyObj) {
        csv = csv + Object.keys(keyObj).join(",") + "\n";
      }
    }
    data.forEach((row) => {
      Object.values(row).forEach((v) => {
        if (typeof v === "string") {
          let escaped = v.replace(/"/g, '""');
          if (escaped.search(/("|,|\n)/g) >= 0) {
            csv = csv + '"' + escaped + '"';
          } else {
            csv = csv + escaped;
          }
        } else if (typeof v === "object") {
          csv = csv;
        } else if (typeof v === "array") {
          csv = csv + v.toString();
        } else if (v === parseInt(v,10)) {
          try {
            let d = new Date(v);
            //numeric values are  unlikely to convert to a date after 1/1/2000 
            if (moment(v).isAfter("2000-01-01")) {
              csv = csv + '"' + moment(v).format("lll") + '"';
            } else {
              csv = csv + v;
            }
          } catch (x) {
            csv = csv + v;
          }

        } else {
          csv = csv + v;
        }
        csv = csv + ",";
      });
      csv = csv + "\n";
    });
    csv = "data:text/csv;charset=utf-8," + csv;
    let encodedURI = encodeURI(csv);
    let link = document.createElement("a");
    link.setAttribute("href", encodedURI);
    link.setAttribute(
      "download",
      this.props.t(this.props.portlet.title).replaceAll(" ", "-") + ".csv"
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // const fileType =
    //   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    // const fileExtension = ".xlsx";
    // const ws = XLSX.utils.json_to_sheet(
    //   this.prepareDownloadData(this.state.data)
    // );
    // const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    // const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    // const data = new Blob([excelBuffer], { type: fileType });
    // FileSaver.saveAs(
    //   data,
    //   this.props.t(this.props.portlet.title).replaceAll(" ", "-") +
    //     fileExtension
    // );
  };
  parseParams = (params) => {
    const keys = Object.keys(params);
    let options = "";

    keys.forEach((key) => {
      const isParamTypeObject = typeof params[key] === "object";
      const isParamTypeArray =
        isParamTypeObject && params[key] && params[key].length >= 0;

      if (!isParamTypeObject) {
        options += `${key}=${params[key]}&`;
      }

      if (isParamTypeObject && isParamTypeArray) {
        params[key].forEach((element) => {
          options += `${key}=${element}&`;
        });
      }
    });

    return options ? options.slice(0, -1) : options;
  };

  /**
   * This method should only be called on UserList portlets
   */
  saveList = () => {
    if (
      this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.list.UserListInterface" &&
      Object.keys(JSON.parse(this.props.portlet.parameters)).length === 1
    ) {
      this.setState({ savingList: true });
      axios
        .patch(
          `/userlist/${JSON.parse(this.props.portlet.parameters).listID}`,
          {
            id: JSON.parse(this.props.portlet.parameters).listID,
            items: JSON.stringify(this.state.data),
          }
        )
        .then(() => this.setState({ savingList: false }))
        .catch(() => this.setState({ savingList: false }));
    }
  };

  returnPlaceholder = (ListItem) => (provided, snapshot, rubric) => {
    const element = this.state.data[rubric.source.index];
    return (
      <div {...provided.draggableProps} {...provided.dragHandleProps}>
        <ListItem
          onItemRemove={this.onItemRemove}
          itemIndex={rubric.source.index}
          data={element}
          filters={
            !!this.props.portlet.parameters
              ? JSON.parse(this.props.portlet.parameters)
              : {}
          }
        />
      </div>
    );
  };

  returnItem = (snapshot, provided, ListItem, withoutClasses, idx) => {
    let element = this.state.data[idx];
    if (!element || Object.keys(element).length < 1) return null;
    const shouldRenderClone =
      `draggable-${hash(element)}` === snapshot.draggingFromThisWith;
    if (shouldRenderClone) {
      if (
        this.props.messageType ===
        "com.kpsol.api.apicommon.list.UserListInterface"
      ) {
        // virtuoso has problems with 0 sized items. if we don't render anything when
        // dragging an item it deletes items on drop, so we have to render a 1px div
        // to ensure all the elements are kept on drop: https://github.com/petyosi/react-virtuoso/issues/35
        return <div style={{ height: 1 }} />;
      } else {
        return (
          <ListItem
            onItemRemove={this.onItemRemove}
            itemIndex={idx}
            data={element}
            fullscreen={
              this.props.fullscreen === true || this.state.fullwidth === true
                ? true
                : false
            }
            menuDialog={this.props.menuDialog}
            preText={this.props.preText}
            // filters={
            //   !!this.props.portlet.parameters
            //     ? JSON.parse(this.props.portlet.parameters)
            //     : {}
            // }
            filters={this.state.parameters ? this.state.parameters : {}}
          />
        );
      }
    }
    return (
      <Draggable
        key={element.type ? `${element.type}-${element.id}` : idx}
        draggableId={`draggable-${hash(element)}`}
        index={idx}
        isDragDisabled={this.props.listOnly}
      >
        {(provided, snapshot) => (
          <>
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
            >
              {this.props.listItem && (
                <ListItem
                  // showSnackbar={(text) =>
                  //   this.setState({ showSnackbar: true, snackbarText: text })
                  // }
                  noIcons={this.props.noIcons}
                  onItemRemove={this.onItemRemove}
                  itemIndex={idx}
                  provided={provided}
                  data={element}
                  snapshot={snapshot}
                  extendedSettings={this.props.portlet.settingsExtended}
                  listSettings={this.props.portlet.settingsList}
                  fullscreenSettings={this.props.portlet.settingsFullscreen}
                  fullscreen={this.props.fullscreen || this.state.fullwidth}
                  menuDialog={this.props.menuDialog}
                  {...withoutClasses}
                  // filters={
                  //   !!this.props.portlet.parameters
                  //     ? JSON.parse(this.props.portlet.parameters)
                  //     : {}
                  // }
                  filters={this.state.parameters ? this.state.parameters : {}}
                />
              )}
            </div>
          </>
        )}
      </Draggable>
    );
  };
  setScrolling = (scrolling) => {
    this.state.scrolling != scrolling &&
      this.setState({ scrolling: scrolling });
  };
  getDefaultExtendedSetting() {
    let settings;
    let extS = [];
    switch (this.props.portlet.objectClass) {
      case "com.kpsol.api.apicommon.document.DocumentInterface":
      case "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface":
      case "com.kpsol.api.apicommon.document.ReportInterface":
        settings = this.props.documentOptions;
        break;
      case "com.kpsol.api.apicommon.discussions.DiscussionIndexInterface":
        settings = this.props.discussionOptions;
        break;
      case "com.kpsol.api.apicommon.discussions.EntryInterface":
        settings = this.props.discussionEntryOptions;
        break;
      case "com.kpsol.api.apicommon.history.SearchHistoryInterface":
        settings = this.props.searchHistoryOptions.filter((o) => {
          return (
            o !== "settings_searchhistory_numberOfResults" &&
            o !== "settings_searchhistory_userCount"
          );
        });
        break;
      case "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface":
        settings = this.props.searchHistoryOptions;
        break;
      case "com.kpsol.api.apicommon.rework.ReworkInterface":
        settings = this.props.reworkOptions;
        break;
      case "com.kpsol.api.apicommon.requiredreading.RequiredReadingInterface":
        settings = this.props.requiredReadingOptions;
        break;
      case "com.kpsol.api.apicommon.content.KnowledgeItemInterface":
        settings = this.props.knowledgeItemOptions;
        break;
      case "com.kpsol.api.apicommon.expertquestion.ExpertQuestionInterface":
        settings = this.props.expertQuestionOptions;
        break;
      default:
        settings = [];
    }

    for (var i = 0; i < settings.length; i++) {
      extS.push({ label: settings[i], order: i });
    }
    return extS;
  }
  setSort = (sortColumn) => (event) => {
    //if we are fullscreen a menu portlet or a portlet over 2 columns we display as a table and the table headers sort
    try {
      let parameters = this.state.parameters;
      if (parameters.sort !== sortColumn) {
        parameters.sort = sortColumn;
      } else {
        //swap the current direction
        parameters.sortDirection =
          parameters.sortDirection === "DESC" ? "ASC" : "DESC";
      }

      this.props.menuDialog
        ? this.sendRequest(parameters, false, null)
        : this.props.updatePortlet(parameters);
    } catch (x) {}
  };
  getFullScreenTableHeader = (provided, snapshot) => {
    return this.state.settingsFullscreen.map((setting, index) => {
      let sortable = this.state.columnSorts.filter(
        (el) => el.label === setting.label
      );
      return (
        <Draggable
          key={setting.label + "-" + index}
          draggableId={setting.label + "-" + index}
          index={index}
        >
          {(provided, snapshot) => {
            const style = {
              ...provided.draggableProps.style,
            };
            const usePortal = snapshot && snapshot.isDragging;
            const child = (
              <>
                {(setting.label !== "settings_document_rework_count" ||
                  this.props.currentUser.userPermits.roles.beExpert) && (
                  <TableCell
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={style}
                    inPortal={usePortal}
                  >
                    {sortable.length > 0 ? (
                      <TableSortLabel
                        active={
                          this.state.parameters &&
                          this.state.parameters.sort &&
                          this.state.parameters.sort === sortable[0].value
                        }
                        direction={
                          this.state.parameters &&
                          this.state.parameters.sortDirection
                            ? this.state.parameters.sortDirection.toLowerCase()
                            : "asc"
                        }
                        onClick={this.setSort(sortable[0].value)}
                      >
                        {this.props.t(setting.label)}
                      </TableSortLabel>
                    ) : (
                      <>{this.props.t(setting.label)}</>
                    )}
                  </TableCell>
                )}
              </>
            );
            if (usePortal) {
              return ReactDOM.createPortal(child, document.body);
            }
            return child;
          }}
        </Draggable>
      );
    });
  };

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };
  onColumnDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const updatedSettings = this.reorder(
      this.state.settingsFullscreen,
      result.source.index,
      result.destination.index
    ).map((el, idx) => {
      return { label: el.label, order: idx };
    });

    this.setState(
      {
        settingsFullscreen: updatedSettings,
      },
      () => this.saveSettings()
    );
  };
  prepareDownloadData = (data) => {
    const itemToMap = this.props.listItemName;
    return data.map((item, index) => {
      let mappedItem = {};
      mappedItem[this.props.t(this.props.listItemTitleColumn.message)] =
        item[this.props.listItemTitleColumn.name];
      this.state.settingsFullscreen.map((setting, index) => {
        let itemMapping = this.props.itemMappings[itemToMap];
        if (itemMapping) {
          let propname = itemMapping.hasOwnProperty(setting.label)
            ? itemMapping[setting.label].data
            : null;
          if (
            propname != null &&
            (propname === "author" ||
              propname === "lastModifiedByUser" ||
              propname === "liveRevisionAuthor") &&
            typeof item[propname] === "object"
          ) {
            if (item[propname] && item[propname].userLogin) {
              let firstName = item[propname].firstName || "";
              let lastName = item[propname].surname || "";
              let userLogin = item[propname].userLogin || "";
              mappedItem[this.props.t(setting.label)] =
                firstName + " " + lastName + " (" + userLogin + ")";
            } else {
              mappedItem[this.props.t(setting.label)] = "";
            }
          } else if (setting.label === "global_topic") {
            mappedItem[this.props.t(setting.label)] = item.hasOwnProperty(
              "topicName"
            )
              ? item.topicName
              : item.hasOwnProperty("topic") &&
                typeof item.topic === "object" &&
                item.topic.hasOwnProperty("topicName")
                ? item.topic.topicName
                : "";
          } else if (setting.label === "settings_document_categories") {
            let categories = this.props.categories.filter((c) => {
              return Array.isArray(item[propname])
                ? item[propname].includes(c.id)
                : false;
            });
            mappedItem[this.props.t(setting.label)] = Array.isArray(categories)
              ? categories.map((c) => c.title).toString()
              : "";
          } else if (setting.label === "document_type" || setting.label === "settings_knowledge_item_document_type_name") {
            let filtered = this.props.documentTypes.filter(t => t.documentTypeID === item["documentTypeId"])
            mappedItem[this.props.t(setting.label)] = filtered.length > 0 ? filtered[0].name : ""
          } else {
            mappedItem[this.props.t(setting.label)] =
              typeof propname !== "undefined" && propname !== null
                ? item[propname] && item[propname] !== "undefined"
                  ? item[propname]
                  : ""
                : "";
          }
        }
      });
      return mappedItem;
    });
  };

  render() {
    const { classes, theme, ...withoutClasses } = this.props;
    const params = this.state.parameters;
    let ListItem = this.props.listItem;
    let isDropDisabled = true;
    if (
      this.props.messageType ===
        "com.kpsol.api.apicommon.document.DocumentInterface" ||
      this.props.messageType ===
        "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface" ||
      this.props.messageType ===
        "com.kpsol.api.apicommon.document.ReportInterface"
    ) {
      if (params) {
        if (params.liked || params.favourited) {
          isDropDisabled = false;
        }
      }
    } else if (
      this.props.messageType ===
        "com.kpsol.api.apicommon.list.UserListInterface" &&
      Object.keys(JSON.parse(this.props.portlet.parameters)).length == 1
    ) {
      isDropDisabled = false;
    }
    const isFullscreen =
      this.props.fullscreen === true || this.state.fullwidth === true
        ? true
        : false;
    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: this.state.listMinHeight,
          minHeight: "100%",
          position: "relative",
        }}
      >
        {!this.props.menuDialog &&
        !this.props.fullscreen &&
        !this.state.fullwidth ? (
          <Droppable
            isDropDisabled={isDropDisabled}
            droppableId={`droppable-${this.props.portlet.id}`}
            renderClone={this.returnPlaceholder(ListItem)}
          >
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={this.getListStyle(snapshot.isDraggingOver)}
              >
                {this.state.loading ? (
                  <>
                    {Array.from(
                      Array(this.props.rows ? this.props.rows * 4 : 4)
                    ).map(() => {
                      return (
                        <div style={{ marginTop: 4, marginBottom: 12 }}>
                          <Skeleton
                            variant="rect"
                            style={{ width: "35%", marginBottom: 5 }}
                            height={25}
                            animation="wave"
                          />
                          <Skeleton
                            variant="rect"
                            style={{ width: "90%" }}
                            height={25}
                            animation="wave"
                          />
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <>
                    {this.state.error ? (
                      <div>
                        <Typography
                          variant="body2"
                          className={classes.centerText}
                        >
                          <Trans i18nKey="portlet_error" />
                        </Typography>
                      </div>
                    ) : (
                      <>
                        {this.state.data.length === 0 && (
                          <div>
                            <Typography
                              variant="body2"
                              className={classes.centerText}
                            >
                              <Trans i18nKey="portlet_empty" />
                            </Typography>
                          </div>
                        )}
                        <AutoSizer>
                          {({ height, width }) => (
                            <>
                              {/* <div style={{
                              height: "30px",
                              }}> 
                            </div> */}
                              <Virtuoso
                                aria-label={`Items for portlet ${this.props.t(
                                  this.props.portlet.title
                                )}`}
                                overscan={{ main: 200, reverse: 1000 }}
                                computeItemKey={(idx) => {
                                  let item = this.state.data[idx];
                                  if (item) {
                                    if (item.messageId) {
                                      return item.messageId;
                                    }
                                  }
                                  return idx;
                                }}
                                totalCount={this.state.data.length}
                                itemContent={(idx) =>
                                  this.returnItem(
                                    snapshot,
                                    provided,
                                    ListItem,
                                    withoutClasses,
                                    idx
                                  )
                                }
                                defaultItemHeight={63}
                                endReached={() => {
                                  if (
                                    !this.props.currentUser.userSettings || !this.props.currentUser.userSettings
                                      .disableInfiniteLists
                                  ) {
                                    this.getData();
                                  }
                                }}
                                components={{
                                  Footer: () => {
                                    return (
                                      <>
                                        {!this.state.isAtEnd && (
                                          <>
                                            {this.props.currentUser.userSettings &&
                                              this.props.currentUser.userSettings.disableInfiniteLists ? (
                                              <div
                                                style={{
                                                  padding: "1rem",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <Button
                                                  size="small"
                                                  onClick={this.getData}
                                                >
                                                  {this.props.t(
                                                    "list_click_to_load_more"
                                                  )}
                                                </Button>
                                              </div>
                                            ) : (
                                              <div
                                                style={{
                                                  padding: "2rem",
                                                  textAlign: "center",
                                                }}
                                              >
                                                {this.props.t(
                                                  "portlet_loading"
                                                )}
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </>
                                    );
                                  },
                                }}
                                style={{ width: width, height: height }}
                                isScrolling={(scrolling) =>
                                  this.setScrolling(scrolling)
                                }
                              />
                            </>
                          )}
                        </AutoSizer>
                        {provided.placeholder}
                      </>
                    )}
                  </>
                )}
              </div>
            )}
          </Droppable>
        ) : this.props.fullscreen ||
        // (this.props.menuDialog && !this.props.isMobile) ||
        this.props.menuDialog ||
        this.state.fullwidth ? (
          <>
            <div className={classes.paginationContainer}>
              <div style={{ flex: 1 }}>
                <Typography
                  style={{
                    display: "inline-block",
                    marginRight: 10,
                    marginTop: 4,
                  }}
                >
                  {this.props.t("search_results_per_page")}
                </Typography>
                <FormControl className={classes.formControl}>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={this.state.fullscreenPageSize}
                    onChange={(e) =>
                      this.setState({ fullscreenPageSize: e.target.value })
                    }
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <Pagination
                count={Math.ceil(
                  this.state.totalItems / this.state.fullscreenPageSize
                )}
                page={this.state.page + 1}
                onChange={(_e, v) => {
                  this.setState({ page: v - 1 });
                }}
                color="primary"
              />
              <div
                style={{
                  flex: 1,
                  textAlign: "right",
                  marginRight: theme.spacing(4),
                }}
              >
                <Tooltip
                  placement="left-end"
                  title={
                    <Typography>
                      {this.props.t("card_list_download_page_data")}
                    </Typography>
                  }
                >
                  <Link
                    component="button"
                    onClick={() => {
                      this.exportToCSV();
                    }}
                  >
                    <GetAppIcon fontSize="large" />
                  </Link>
                </Tooltip>
              </div>
            </div>
            <AutoSizer>
              {({ height, width }) => (
                <div>
                  <TableContainer
                    style={{
                      width: width - theme.spacing(2),
                      maxHeight:
                        !this.props.isMobile && height - theme.spacing(10),
                    }}
                  >
                    <Table stickyHeader size="small" sx={"max-content"}>
                      {this.state.settingsFullscreen.length > 0 && (
                        <DragDropContext onDragEnd={this.onColumnDragEnd}>
                          <Droppable
                            droppableId="droppable"
                            direction="horizontal"
                          >
                            {(provided, snapshot) => (
                              <TableHead
                                ref={provided.innerRef}
                                style={this.getTableHeaderStyle(
                                  snapshot.isDraggingOver
                                )}
                                {...provided.droppableProps}
                              >
                                <>
                                  {!this.props.noIcons &&
                                    // this.props.listItemName ===
                                    //   "DocumentItem" &&
                                    // ((this.props.properties[
                                    //   PropertyNames.DISPLAY_NEW_TAB_ICON
                                    // ] === "true" ||
                                    //   this.props.properties[
                                    //     PropertyNames
                                    //       .DISPLAY_NEW_DOCUMENT_PORTLET_ICON
                                    //   ] === "true") || (this.props.listItemName ===
                                    //   "DiscussionItem" && this.props.dsfds)) && (
                                    this.props.firstItemButton && (this.props.fullscreen || this.state.fullwidth) && (
                                      <TableCell className={classes.sticky}>
                                        <></>
                                      </TableCell>
                                    )}
                                </>
                                <TableCell>
                                  {this.state.columnSorts.length > 0 &&
                                    this.props.listItemTitleColumn &&
                                    this.props.listItemTitleColumn !== null && (
                                      <TableSortLabel
                                        active={
                                          params &&
                                          params.sort ===
                                            this.state.columnSorts.filter(
                                              (el) =>
                                                el.label ==
                                                this.props.listItemTitleColumn
                                                  .message
                                            )[0].value
                                        }
                                        direction={
                                          params && params.sortDirection
                                            ? params.sortDirection.toLowerCase()
                                            : "asc"
                                        }
                                        onClick={this.setSort(
                                          this.state.columnSorts.filter(
                                            (el) =>
                                              el.label ==
                                              this.props.listItemTitleColumn
                                                .message
                                          )[0].value
                                        )}
                                      >
                                        {this.props.t(
                                          this.props.listItemTitleColumn.message
                                        )}
                                      </TableSortLabel>
                                    )}
                                </TableCell>
                                {this.getFullScreenTableHeader(
                                  provided,
                                  snapshot
                                )}
                              </TableHead>
                            )}
                          </Droppable>
                        </DragDropContext>
                      )}
                      <TableBody>
                        {this.state.data.map((element, idx) => {
                          // const isFullscreen =
                          //   this.props.fullscreen === true ||
                          //   this.state.fullwidth === true
                          //     ? true
                          //     : false;
                          return (
                            <>
                              {this.props.listItem && (
                                <ListItem
                                  {...withoutClasses}
                                  onItemRemove={this.onItemRemove}
                                  itemIndex={idx}
                                  data={element}
                                  extendedSettings={
                                    this.props.portlet.settingsExtended
                                  }
                                  listSettings={this.props.portlet.settingsList}
                                  fullscreenSettings={
                                    this.props.portlet.settingsFullscreen
                                  }
                                  menuDialog={this.props.menuDialog}
                                  fullscreen={
                                    this.props.fullscreen === true ||
                                    this.state.fullwidth === true
                                  }
                                  // filters={
                                  //   !!this.props.portlet.parameters
                                  //     ? JSON.parse(
                                  //         this.props.portlet.parameters
                                  //       )
                                  //     : {}
                                  // }
                                  filters={
                                    this.state.parameters
                                      ? this.state.parameters
                                      : {}
                                  }
                                />
                              )}
                            </>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
            </AutoSizer>
          </>
        ) : (
          <div style={{ height: "100%" }}>
            {this.state.data.map((element, idx) => {
              return (
                <>
                  {this.props.listItem && (
                    <ListItem
                      onItemRemove={this.onItemRemove}
                      itemIndex={idx}
                      data={element}
                      // filters={
                      //   !!this.props.portlet.parameters
                      //     ? JSON.parse(this.props.portlet.parameters)
                      //     : {}
                      // }
                      filters={
                        this.state.parameters ? this.state.parameters : {}
                      }
                      key={idx}
                      {...withoutClasses}
                    />
                  )}
                </>
              );
            })}
          </div>
        )}
        {/* <Snackbar
          open={this.state.showSnackbar}
          onClose={() => this.setState({ showSnackbar: false })}
        >
          <Alert severity="info">
            <Trans i18nKey={this.state.snackbarText} />
          </Alert>
        </Snackbar> */}
      </div>
    );
  }
  saveSettings() {
    let portlet = {
      ...this.props.portlet,
      settingsExtended: this.props.portlet.settingsExtended,
      settingsFullscreen: JSON.stringify(this.state.settingsFullscreen),
      settingsList: this.props.portlet.settingsList,
    };
    !this.props.menuDialog
      ? axios
          .patch(
            `/portalLayout/${this.props.portlet.portalLayoutID}/portlet/${
              this.props.portlet.id
            }`,
            portlet
          )
          .then((res) => {
            PubSub.publish(PORTLET_LAYOUT_UPDATE, { portlet: res.data });
          })
      : this.props.updateMenuPortlet(portlet);
  }
  getListStyle = (isDraggingOver) => ({
    background: isDraggingOver
      ? this.props.theme.palette.grey[300]
      : this.props.theme.palette.common.white,
    height: "100%",
    flex: 1,
    marginLeft: 10,
    position: "static",
  });
  getTableHeaderStyle = (isDraggingOver) => ({
    background: isDraggingOver
      ? this.props.theme.palette.grey[300]
      : this.props.theme.palette.common.white,
    // width:"100%",
    // height: "100%",
    margin: 0,
    padding: 0,
    border: 1,
    flex: 1,
  });

  onItemRemove = (index) => {
    let list = [...this.state.data];
    list.splice(index, 1);
    this.setState({ data: list });
  };

  reorderList = (startIndex, endIndex) => {
    let list = Array.from(this.state.data);

    const [removed] = list.splice(startIndex, 1);
    list.splice(endIndex, 0, removed);
    this.setState({ data: list });
  };

  removeFromList = (index) => {
    let list = [...this.state.data];
    let deleted = list[index];
    return deleted;
  };

  addToList = (index, element) => {
    let list = [...this.state.data];
    let toSave = element;
    if (
      this.props.messageType ===
        "com.kpsol.api.apicommon.document.DocumentInterface" ||
      this.props.messageType ===
        "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface" ||
      this.props.messageType ===
        "com.kpsol.api.apicommon.document.ReportInterface"
    ) {
      let params = JSON.parse(this.props.portlet.parameters);
      if (!params.liked && !params.favourited) return;
      var documentRVO = {};
      documentRVO.documentID = element.documentID || element.id;
      documentRVO.documentURL = element.documentURL;

      if (params.liked) {
        documentRVO.myLiked = true;
      }
      if (params.favourited) {
        documentRVO.favourite = true;
      }

      axios
        .patch(`/document/${documentRVO.documentID}`, {
          ...documentRVO,
        })
        .then((res) => {
          this.getData(true);
        });
    } else {
      if (element.documentID) {
        toSave = {
          type: "document",
          id: element.documentID,
          comment: "",
        };
      } else if (element.requiredReadingDocuments) {
        toSave = {
          type: "requiredReading",
          id: element.id,
          comment: "",
        };
      } else if (element.entryId) {
        toSave = {
          type: "entry",
          id: element.entryId,
          comment: "",
        };
      } else if (element.discussionId) {
        toSave = {
          type: "discussion",
          id: element.discussionId,
          comment: "",
        };
      } else if (element.itemId) {
        toSave = {
          type: "knowledgeItem",
          id: element.itemId,
          comment: "",
        };
      } else if (element.searchGroupId) {
        toSave = {
          type: "searchGroup",
          id: element.searchGroupId,
          comment: "",
        };
      }

      list.splice(index, 0, toSave);
      this.setState({ data: list });
    }
  };
}

const mapStateToProps = (state) => ({
  //notifications: state.user.notifications,
  documentOptions: state.selectionOption.documentSettingsOptions,
  discussionOptions: state.selectionOption.discussionSettingsOptions,
  discussionEntryOptions: state.selectionOption.discussionEntrySettingsOptions,
  searchOptions: state.selectionOption.searchSettingsOptions,
  listUserListOptions: state.selectionOption.listUserListSettingsOptions,
  templateOptions: state.selectionOption.templateSettingsOptions,
  reworkOptions: state.selectionOption.reworkSettingsOptions,
  requiredReadingOptions: state.selectionOption.requiredReadingSettingsOptions,
  knowledgeItemOptions: state.selectionOption.knowledgeItemSettingsOptions,
  expertQuestionTemplateOptions:
    state.selectionOption.expertQuestionTemplateSettingsOptions,
  expertQuestionOptions: state.selectionOption.expertQuestionSettingsOptions,
  ContentRevisionOptions: state.selectionOption.contentRevisionSettingsOptions,
  searchHistoryOptions: state.selectionOption.searchHistorySettingsOptions,
  itemMappings: state.itemMappings,
  currentUser: state.user.currentUser,
  properties: state.setting.applicationProperties,
  taxonomyNodeLookup: state.taxonomy.taxonomyNodeLookup,
  categories: state.prefs.documentCategories,
  isMobile: state.screen.isMobile,
  documentTypes: state.prefs.documentTypes,
});

export default connect(
  mapStateToProps,
  null
)(withTheme(CoreCard(withStyles(styles)(withTranslation()(CardList)))));
